// extracted by mini-css-extract-plugin
export var active = "_ta-1";
export var circle = "_ta-0";
export var completed = "_ta-2";
export var connector = "_ta-4";
export var connectorCompleted = "_ta-7";
export var connectorSpacer = "_ta-5";
export var iconStrokeOverride = "_ta-8";
export var labelContainer = "_ta-6";
export var pending = "_ta-3";